var GraphicsFillStyle = /** @class */ (function () {
    function GraphicsFillStyle(fillStyle) {
        this.fillStyle = fillStyle;
    }
    Object.defineProperty(GraphicsFillStyle.prototype, "data_type", {
        get: function () {
            return GraphicsFillStyle.data_type;
        },
        enumerable: false,
        configurable: true
    });
    GraphicsFillStyle.data_type = '[graphicsdata FillStyle]';
    return GraphicsFillStyle;
}());
export { GraphicsFillStyle };
